import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LocationActiveComponent } from './location-active.component';

@NgModule({
  declarations: [LocationActiveComponent],
  imports: [CommonModule, MatMenuModule, MatIconModule, TranslocoModule, NgxSkeletonLoaderModule],
  exports: [LocationActiveComponent],
})
export class LocationActiveModule {}
